import { stringify as stringifyQs } from 'query-string';
import { push } from 'redux-little-router';
import {getHelpCategory, getMediaCategory, getMediaIndex, getMediaTime} from "~/stateGetter";

export const SET_SEARCH_TERM = 'set_help_search_term';
export const SET_CATEGORY = 'set_help_category';

export function setSearchTerm(term) {
    return { type: SET_SEARCH_TERM, term }
}

export function setCategory(category) {
    return { type: SET_CATEGORY, category }
}

export function pushHelpPath(helpPath, {media, index, time} = {}, ...args) {
    let hash = '';

    if(media) {
        hash += `${media}`;
        if(index) {
            hash += `,${index}`;
        }

        if(time) {
            hash += `,${index}`;
        }
    }

    hash = hash.length ? `#${hash}` : '';

    if(!helpPath || !helpPath.length) {
        return push(`/help${hash}`, ...args);
    }

    return push(`/help/${helpPath}${hash}`, ...args)
}

export function changeHelpMedia({media, index, time} = {}, ...args) {
    return (dispatch, getState) => {
        let state = getState();

        let normalized = {};
        let currentHelpCategory = getHelpCategory(state);
            normalized.media = typeof media === 'undefined' ? getMediaCategory(state) : media;
            normalized.index = typeof index === 'undefined' ? getMediaIndex(state) : index;
            normalized.time = typeof time === 'undefined' ? getMediaTime(state) : time;

        dispatch(pushHelpPath(currentHelpCategory, normalized, ...args));
    };
};